<template>
  <div>
    <div class="cart_item">
      <p>
        Church Subscription
        <strong>× 1</strong>
      </p>
      <p>
        <span>$</span>
        {{ churchOrder.price }}/{{ churchOrder.plancycle }}
        <template v-if="!isEmpty(couponInfo)">
          <b style="color: #2ba349" v-if="couponInfo.type === 'percent'"> with {{ couponInfo.amount }}{{ couponInfo.unit }} discount </b>
          <b style="color: #2ba349" v-else>with {{ couponInfo.amount }}-{{ couponInfo.unit }} free trial</b>
        </template>
      </p>
    </div>
    <div class="cart_item">
      <p>Recurring Total</p>
      <p>
        <span class="price">${{ churchOrder.price }}</span>
        / {{ churchOrder.plancycle }}
      </p>
      <small>First renewal: {{ extraTrial }}</small>
    </div>
  </div>
</template>
<script>
import { isEmpty } from 'lodash'
export default {
  props: ['couponInfo', 'churchOrder', 'extraTrial'],
  methods: { isEmpty }
}
</script>
